import initialStore from '../initialStore';
import { AuthStore } from '../../types/auth';
import { AuthAction } from '../../types/actions';
import { createResourceModel } from '../../utils/health-resources';


const singleResourceReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SINGLE_RESOURCE_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_SINGLE_RESOURCE_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: createResourceModel(action.resource)
    });
  case 'GET_SINGLE_RESOURCE_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  case 'GET_SINGLE_AGGREGATED_RESOURCE':
    return Object.assign({}, currentState, {
      loading: false,
      aggregatedResource: action.resource
    });
  default:
    return currentState || initialStore.resources;
  }
};

export default singleResourceReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/resource.js